module.exports = __webpack_public_path__ + "img/jiancaideBanner.78a7a964.png";